module.exports = __webpack_public_path__ + "img/app-store.bbcee9d9.svg";